
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("hpDFj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d56696bd7d9bfd51a53fc1726d5b9e10>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cad38a2b50edf218$var$_react = $cad38a2b50edf218$var$_interopRequireDefault((parcelRequire("42omo")));

var $cad38a2b50edf218$var$_baseNew = $cad38a2b50edf218$var$_interopRequireDefault((parcelRequire("aSNrY")));
function $cad38a2b50edf218$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPauseOverlay".
 * Category: single-purpose
 * Location: @atlaskit/icon/core/video-pause-overlay
 * Usage guidance:
 * Single purpose - Reserved for pause video when icon is overlayed on Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cad38a2b50edf218$var$VideoPauseOverlayIcon = (props)=>/*#__PURE__*/ $cad38a2b50edf218$var$_react.default.createElement($cad38a2b50edf218$var$_baseNew.default, Object.assign({
        name: "VideoPauseOverlayIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm7 0a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$cad38a2b50edf218$var$VideoPauseOverlayIcon.displayName = 'VideoPauseOverlayIcon';
var $cad38a2b50edf218$var$_default = module.exports.default = $cad38a2b50edf218$var$VideoPauseOverlayIcon;

});


//# sourceMappingURL=video-pause-overlay.bf3f58b5.js.map
